import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CubeLoader, { DASHBOARD_SIZE, DEFAULT_LOADER_DELAY } from 'common/components/CubeLoader';

const baseClassName = 'CubeLoaderOverlay';

const Container = styled.div`
    position: ${(props) => (props.fixed ? 'fixed' : 'absolute')};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${(props) => props.bgColor || 'transparent'};
`;

const AbsCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const CubeLoaderOverlay = ({
    backgroundColor,
    className,
    delay,
    fixed,
    loading,
    preText,
    size,
    text,
    useAlternate,
    qaId,
}) => {
    if (!loading) {
        return null;
    }

    return (
        <Container bgColor={backgroundColor} className={`${baseClassName} ${className}`} fixed={fixed} data-qa={qaId}>
            <AbsCenter>
                <CubeLoader delay={delay} preText={preText} text={text} size={size} useAlternate={useAlternate} />
            </AbsCenter>
        </Container>
    );
};

CubeLoaderOverlay.propTypes = {
    // [string] Sets the background color for the overlay
    backgroundColor: PropTypes.string,
    // [string] QA Id
    qaId: PropTypes.string,
    // [string] Additional classes to be added to the container div
    className: PropTypes.string,
    // [integer] Sets the delay before the loader is displayed (in ms)
    delay: PropTypes.number,
    // [boolean] Determines if the loader and overlay will be fixed on the page
    fixed: PropTypes.bool,
    // [boolean] Determines if the loader overlay will be displayed
    loading: PropTypes.bool,
    // [string] Smaller test for the normal text.
    preText: PropTypes.string,
    // [string] Size string for the loader
    size: PropTypes.string,
    // [string] Text for the loader.
    text: PropTypes.string,
    // [boolean] If present, the loader will use the white alternate textures for the cubes
    useAlternate: PropTypes.bool,
};

CubeLoaderOverlay.defaultProps = {
    backgroundColor: '',
    className: '',
    qaId: '',
    delay: DEFAULT_LOADER_DELAY,
    fixed: false,
    loading: true,
    preText: '',
    size: DASHBOARD_SIZE,
    text: '',
    useAlternate: false,
};

export default CubeLoaderOverlay;
